import React from 'react';
import type { ComponentType, CSSProperties, ReactNode } from 'react';
import type { BlockRenderProps } from '../render/blocks/types';
import type { BlockSettingsProps } from '../settings/blocks/types';
import type {
  BlockDefinition,
  BlockEditorChrome,
} from '../domain/blocks/types';
import { imageEditorBoxStyle } from '../domain/image-layout';
import type { BlockOf, BlockType, Block } from '../domain/types';

export type BlockRegistryEntry = BlockDefinition &
  BlockEditorChrome & {
    render: (props: BlockRenderProps) => ReactNode;
    renderSettings: (props: BlockSettingsProps) => ReactNode;
  };

export function defineBlockRegistryEntry<T extends BlockType>(
  definition: BlockDefinition,
  render: (props: BlockRenderProps & { block: BlockOf<T> }) => ReactNode,
  Settings: ComponentType<BlockSettingsProps & { block: BlockOf<T> }>,
  editorChrome?: BlockEditorChrome,
): BlockRegistryEntry {
  return {
    ...definition,
    ...editorChrome,
    render: props => render({ ...props, block: props.block as BlockOf<T> }),
    renderSettings: props => (
      <Settings {...(props as BlockSettingsProps & { block: BlockOf<T> })} />
    ),
  };
}

export function blockEditorBoxStyle(
  entry: BlockRegistryEntry,
  block: Block,
  context: { fillColumnImage: boolean },
): CSSProperties | undefined {
  if (block.type === 'image') {
    return imageEditorBoxStyle(block, context.fillColumnImage);
  }
  return entry.boxStyle?.(block, context);
}
